module.exports = __webpack_public_path__ + "static/img/preview-7.40a7e69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/zombs/preview-7.png
// module id = iTbF
// module chunks = 35